import {makeStyles} from "@material-ui/core/styles";
import {Paper, Typography, Grid} from "@material-ui/core";
import AdditionalNotes from "../components/AdditionalNotes";
import StackCard from '../components/StackCard'
import clsx from "clsx";
import Tooltip from '@material-ui/core/Tooltip';
import {useEffect, useState} from "react";
import HelpIcon from '@material-ui/icons/Help';
import StepNavigator from "../components/StepNavigator";

const useStyles = makeStyles((theme) => ({
    container: {
        height: 'calc(100vh - 200px)',
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        flex: '1',
        display: 'flex',
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        background: '#2f3135'
    },
    narrowGrid: {
        '& > .MuiGrid-grid-xs-2': {
            flexGrow: 0,
            maxWidth: '14%',
            flexBasis: '14%',
        },
        '& > .MuiGrid-grid-xs-10': {
            flexGrow: 0,
            maxWidth: '86%',
            flexBasis: '86%',
            '@media (max-width:1366px)': {
                flex: '1',
            },
        }
    },
    pageNavigation: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        borderRadius: theme.shape.borderRadius,
        background: '#32373D',
        boxShadow: '0px 4px 4px #000000',
        padding: '0 !important',
        minWidth: 180,
    },
    pageContent: {
        padding: `0 16px !important`,
        borderRadius: 16,
        overflowY: 'auto',
        maxHeight: 'max(calc(100vh - 240px), 720px)'
    },
    content: {
        flex: "1",
        padding: 16,
        width: '100%',
        textAlign: 'center'
    },
    button: {
        display: 'block',
        padding: theme.spacing(2, 2),
        '@media (max-width:1366px)': {
            padding: theme.spacing(2, 1),
        },
        textAlign: 'center',
        position: 'relative',
        cursor: 'pointer',
        borderRadius: 16,
        fontSize: 16,
        '&:hover': {
            background: '#434A51',
        },
        '&::after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            width: 0,
            height: '100%',
            top: 0,
            right: 0,
            transition: theme.transitions.create('all', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        transition: theme.transitions.create('all', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    buttonActive: {
        background: '#434A51',
        //        borderTopRightRadius: 0,
        //       borderBottomRightRadius: 0,
        //      '&::after': {
        //            right: -32,
        //           background: '#434A51',
        //          width: 32,
        //    },
        transition: theme.transitions.create('all', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    activitiesWrapper: {
        display: 'flex',
        alignItems: 'center',
        height: '100%'
    },
    activitiesBranchSelector: {
        height: '100%',
        background: '#434A51',
        overflowY: 'auto',
        borderRadius: 16,
        width: 200,
        paddingTop: 16,
        paddingBottom: 16
    },
    branchSelectorButton: {
        cursor: 'pointer',
        padding: 16,
    },
    branchSelectorButtonActive: {
        background: '#303539',
        fontWeight: 'bold',
    },
    activitiesGrid: {
        height: '100%',
        display: 'grid',
        width: '100%',
        gridTemplateColumns: "repeat(auto-fill, 320px)",
        alignItems: 'center',
        gridRowGap: 32,
        gridColumnGap: 16,
        overflowY: 'auto',
        justifyContent: 'space-around',
        alignContent: 'baseline',
        '@media (max-width:1440px)': {
            gridTemplateColumns: "repeat(auto-fill, 200px)",
        },
    },
    branchesGrid: {
        display: 'grid',
        gridTemplateColumns: "repeat(auto-fill, 320px)",
        alignItems: 'center',
        gridRowGap: 32,
        gridColumnGap: 16,
        height: '100%',
        overflowY: 'auto',
        justifyContent: 'space-around',
        alignContent: 'baseline',
        '@media (max-width:1440px)': {
            gridTemplateColumns: "repeat(auto-fill, 200px)",
        },
    },
    logoWrapper: {
        background: '#585c60',
        width: '100%',
        maxWidth: 180,
        aspectRatio: '1',
        margin: 'auto',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '100%',
        justifyContent: 'center',
        overflow: 'hidden',
        '& > img': {
            objectFit: 'cover',
            display: 'block',
            margin: 'auto',
            width: '100%',
            height: '100%',
            borderRadius: '100%'
        }
    },
    dot: {
        height: 8,
        width: 8,
        borderRadius: '100%',
        top: 8,
        right: 8,
        background: 'yellow',
        position: 'absolute'
    }
}))

export default function OverviewPage({data, onNext, onPrev, navigateToPage, onUpdate}) {
    const classes = useStyles();
    const [selectedPage, setSelectedPage] = useState('activities');
    const [selectedBranch, setSelectedBranch] = useState(-1);
    const [activities, setActivities] = useState([]);

    useEffect(() => {
        if (selectedBranch === -1) {
            setActivities(data.activities.filter(a => a._id === a.activity_template_id))
        } else {
            setActivities(data.activities.filter(a => a.branch_id === selectedBranch));
        }

    }, [data, selectedBranch])


    useEffect(() => {
        if (data.branches.length === 1 && data.tokenType === 'BRANCH') {
            setSelectedBranch(data.branches[0]._id) // choose the only branch available
        }
    }, [data.branches, data.tokenType])


    const handleNoteChange = (value) => {
        //asdf
        const note = {
            sourceId: data.provider._id,
            type: data.tokenType === 'BRANCH' ? 'PROVIDER_BRANCH_NOTE' : 'PROVIDER_NOTE',
            content: value,
        }
        onUpdate({
            ...data,
            provider: {
                ...data.provider,
                note: note,
            }
        })
    }

    const handleActivityClick = (activityId) => () => {
        let branchId = -2;
        if (selectedBranch !== -1) {
            branchId = selectedBranch;
        }
        navigateToPage(2, {branch: branchId, activity: activityId});
    }

    const renderPage = (page) => {
        switch (page) {
            case 'activities':
                return (
                    <div className={classes.activitiesWrapper}>
                        {
                            data.tokenType !== "BRANCH" && (
                                <div className={classes.activitiesBranchSelector}>
                                    <div className={clsx(classes.branchSelectorButton, {[classes.branchSelectorButtonActive]: (selectedBranch === -1)})}
                                        onClick={() => setSelectedBranch(-1)} >All Branches</div>
                                    {data.branches.map((branch, i) => (
                                        <div className={clsx(classes.branchSelectorButton, {[classes.branchSelectorButtonActive]: (selectedBranch === branch._id)})}
                                            key={i} onClick={() => setSelectedBranch(branch._id)}>
                                            {branch?.info?.name}
                                        </div>
                                    ))}
                                </div>
                            )
                        }
                        <div className={classes.activitiesGrid}>
                            {
                                activities.map((activity, i) => (
                                    <StackCard key={i}
                                        title={activity?.info?.name}
                                        imageCount={activity.images.length}
                                        images={activity.images}
                                        onClick={handleActivityClick(activity._id)}
                                    />
                                ))
                            }
                        </div>
                    </div>
                )
            case 'branches':
                return (
                    <div className={classes.branchesGrid}>
                        {
                            data.branches.map(branch => (
                                <StackCard
                                    key={branch._id}
                                    title={branch?.info?.name}
                                    onClick={() => navigateToPage(3, {branch: branch._id})}
                                    imageCount={branch.images.length}
                                    images={branch.images}
                                    children={
                                        <div style={{background: 'rgba(132, 132, 132, 0.4)', padding: 8, borderRadius: 4, position: 'relative'}}>
                                            <Typography variant="subtitle1">Trade License</Typography>
                                            {
                                                branch?.tradeLicense != null ? (
                                                    <Typography variant="subtitle2">Trade license file</Typography>
                                                ) : (
                                                    <div className={classes.dot} />
                                                )
                                            }
                                        </div>
                                    } />
                            ))
                        }

                    </div>
                )
            default:
                return null;
        }
    }

    return (
        <>
            <Paper className={classes.container}>
                <Grid container spacing={1} className={classes.narrowGrid}>
                    <Grid className={classes.pageNavigation} item xs={2}>
                        <div className={classes.content}>
                            <Tooltip title={data?.provider?.info?.name}>
                                <Typography variant="h5" style={{marginBottom: 32, marginTop: 16, width: '100%', maxHeight: '2rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                    {data?.provider?.info?.name}
                                </Typography>
                            </Tooltip>
                            <div className={classes.logoWrapper}>
                                {(data?.provider?.logo == null) ? (<HelpIcon style={{fontSize: '6rem'}} />) : (<img src={data?.provider?.logo?.editedUri} alt="Logo" />)}
                            </div>
                            <div
                                style={{marginTop: 16}}
                                onClick={() => setSelectedPage('activities')}
                                className={clsx(classes.button, {[classes.buttonActive]: selectedPage === 'activities'})}>Activities
                            </div>
                            <div
                                onClick={() => setSelectedPage('branches')}
                                className={clsx(classes.button, {[classes.buttonActive]: selectedPage === 'branches'})}>Branches
                            </div>
                            <div style={{flex: '1', marginTop: 8}}>
                                <Typography gutterBottom variant="caption">
                                    Please proceed to the next step only after uploading the pictures for the logo, the activities and the branch(es) along with the trade license for the branch(es).
                                </Typography>
                            </div>
                        </div>
                        <AdditionalNotes value={data.provider?.note?.content} onChange={handleNoteChange} />
                    </Grid>
                    <Grid className={classes.pageContent} item xs={10} >
                        {renderPage(selectedPage)}
                    </Grid>
                </Grid>

            </Paper>
            <StepNavigator onNext={onNext} onPrev={onPrev} />
        </>
    )
}
